<script setup lang="ts">
import type {Populated} from '~/types/populated'
import type {Technology, Media} from '~/types/legacy'

type TechnologyPreview = Populated<Technology> & {
  image: Populated<Media>
}

defineProps<{
  tech: TechnologyPreview
}>()

const {handleMove, handleOut} = useFloatingCard()
</script>

<template>
  <figure
    ref="element"
    @mousemove="handleMove"
    @mouseout="handleOut"
    class="flex flex-col items-center justify-center"
    :class="['rounded-lg p-2 xs:p-4 sm:p-6', 'flex flex-col items-center', 'hover:bg-white hover:bordershadow-lg-gray']"
    :style="{transition: 'box-shadow 0.1s, transform 0.1s, background 0.1s'}"
  >
    <img
      v-if="tech.image"
      v-bind="resolveMediaProps(tech.image)"
      :title="tech.name"
      class="pointer-events-none h-10 object-contain"
    />
    <figcaption class="pointer-events-none mt-4 text-center text-sm text-gray-400">
      {{ tech.name }}
    </figcaption>
  </figure>
</template>
